import { __awaiter, __decorate } from "tslib";
import { attr, customElement } from '@microsoft/fast-element';
import { BaseDatasource, logger } from '../utils';
let MultiselectDatasource = class MultiselectDatasource extends BaseDatasource {
    constructor() {
        super(...arguments);
        this.isSnapshot = true;
    }
    connectedCallback() {
        const _super = Object.create(null, {
            connectedCallback: { get: () => super.connectedCallback }
        });
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            _super.connectedCallback.call(this);
            this.fields = this.labelField ? (_a = this.valueField) === null || _a === void 0 ? void 0 : _a.concat(' ', this.labelField) : this.valueField;
            this.select = this.parentElement;
            if (this.select &&
                this.valueField &&
                ((this.resourceName && this.connect.isConnected) || this.data)) {
                this.fetchGenesisData();
            }
            if (!this.valueField) {
                logger.warn('Specify field for values in options (e.g value-field="VALUE") and optionally field for label which is supported only in select and combobox (e.g label-field="NAME")');
            }
        });
    }
    clearData() {
        this.select.options = [];
    }
    syncComponentData(snapshotData) {
        var _a;
        const rowData = snapshotData !== null && snapshotData !== void 0 ? snapshotData : Array.from(this.rowsSyncedWithStream.values());
        const options = rowData.map((row) => ({
            value: row[this.valueField],
            label: row[this.labelField],
        }));
        if ((_a = this.select) === null || _a === void 0 ? void 0 : _a.async) {
            this.select.loading = false;
        }
        this.select.options = options;
    }
    handleStreamInserts(insertedRows) {
        logger.debug('handleStreamInserts - Method not implemented.');
    }
    handleStreamDeletes(deletedRows) {
        logger.debug('handleStreamDeletes - Method not implemented.');
    }
    handleStreamUpdates(updatedRows) {
        logger.debug('handleStreamUpdates - Method not implemented.');
    }
};
__decorate([
    attr({ attribute: 'value-field' })
], MultiselectDatasource.prototype, "valueField", void 0);
__decorate([
    attr({ attribute: 'label-field' })
], MultiselectDatasource.prototype, "labelField", void 0);
MultiselectDatasource = __decorate([
    customElement({
        name: 'multiselect-datasource',
    })
], MultiselectDatasource);
export { MultiselectDatasource };
